import React from "react";

import "./App.css";
import { LandingPage } from "./Components/LandingPage";
import { Privacy } from "./Components/Privacy";

function App() {
  const [sttScreen, setScreen] = React.useState("");
  React.useEffect(() => {
    console.log(window.location.pathname);
    if (window.location.pathname === "/privacy-policy") {
      document.title = "Morfos Tecnologia - Política de Privacidade";
      setScreen("privacy");
    }
  }, []);

  return <div>{sttScreen === "privacy" ? <Privacy /> : <LandingPage />}</div>;
}

export default App;
